import { LitElement } from '~/lib/bn-lit-element';
import { renderIf, css, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import './import-mapping-target';

class ImportCsvHeaders extends LitElement {
  static get properties() {
    return {
      draggable: { type: Boolean },
      headers: { type: Array },
      recordPreview: { type: Object },
      selectedHeaders: { type: Array },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      .header {
        padding: 8px 12px;
        font-size: smaller;
        flex-grow: 1;
        overflow: auto;
        overflow-wrap: break-word;
      }
      .draggable {
        cursor: grab;
        box-shadow: 0 3px 4px var(--gray-50);
      }
      .draggable:hover {
        box-shadow: 0 6px 6px var(--gray-40);
        transform: translateY(-3px);
      }
      .drag-in-progress {
        opacity: 0.5;
      }
      .headers {
        display: flex;
        flex-direction: column;
      }
      .header-container {
        color: var(--blue-60);
        background-color: var(--blue-20);
        margin-top: 0.5em;
        display: flex;
        align-items: center;
      }
      .check-icon {
        margin-right: 0.5em;
        font-size: large;
      }
      .drag-indicator {
        margin-top: 1px;
        font-size: 16px;
      }
      .drag-indicator.right {
        margin-right: 5px;
        margin-left: 1px;
      }
      .header-name {
        font-weight: bold;
      }
      .preview {
        font-style: italic;
      }
    `];
  }

  render() {
    const { headers } = this;
    if (!headers) {
      return html``;
    }

    const selectedHeaders = this.selectedHeaders || [];
    const recordPreview = this.recordPreview || {};

    return html`
      <div class="headers">
        ${headers.map((header) => html`
          <div
            class="header-container ${this.draggable ? 'draggable' : ''}"
            draggable="${!!this.draggable}"
            @dragstart="${this._onDragStart}"
            @dragend="${this._onDragEnd}"
          >
            <span class="header">
              <div class="header-name">
                ${header}
              </div>
              ${renderIf(recordPreview[header], () => html`
                <div class="preview">${recordPreview[header]}</div>
              `)}
            </span>
            ${renderIf(selectedHeaders.includes(header), () => html`
              <bn-icon class="check-icon" name="fas fa-check-circle"></bn-icon>
            `)}
            ${renderIf(this.draggable, html`
              <bn-icon class="drag-indicator" name="far fa-ellipsis-v"></bn-icon>
              <bn-icon class="drag-indicator right" name="far fa-ellipsis-v"></bn-icon>
            `)}
          </div>
        `)}
      </div>
    `;
  }

  _onDragStart(e) {
    const header = e.target.querySelector('.header-name').innerText;
    e.dataTransfer.setData('text/plain', header);
    e.dataTransfer.dropEffect = 'move';
    e.target.classList.add('drag-in-progress');
  }

  _onDragEnd(e) {
    e.target.classList.remove('drag-in-progress');
  }
}

window.customElements.define('import-csv-headers', ImportCsvHeaders);
